import { george, pr, React, theme, ui, config } from "aaa";
import { IStoreProduct, getProductUrl, IStorePlugin, replaceAdditionalParams } from "./StoreStore";
import { IDS } from "i18n/util";
import LinesEllipsis from "react-lines-ellipsis";
import { IPlugin } from "types/plugins";
import { STORE_BORDER_RADIUS } from "./ProductThumbnailBig";
import externalInterfaceStore from "stores/ExternalInterfaceStore";

export const THUMBNAIL_SMALL_WIDTH = 290;

export const ProductThumbnailSmall = (props: {
    isLoading?: boolean,
    item?: IStoreProduct | IStorePlugin,
    marginRight?: number,
    marginBottom?: number,
    width?: number,
    onClick?: () => void,
}) => {
    // Not loading anymore, but no product or plugin
    if (!props.isLoading
        && !props.item
    ) {
        return null;
    }

    const PADDING = 16;
    const width = (props.width ? props.width : THUMBNAIL_SMALL_WIDTH) - 2 * PADDING;

    let url;
    let text;
    let name;

    const image = props.item?.imageSmall ? `${config.network.imageBaseUrl}${props.item.imageSmall}` : "";

    if (props.item?.type === "PRODUCT") {
        const product = props.item as IStoreProduct;
        const title = product.title; // product.titleId ? ui.__(product.titleId) : null;
        url = getProductUrl(product);

        if (url && product.openInExternalBrowser && externalInterfaceStore.isGeorgeApp) {
            url = `georgeapp://at/open_external_link?url=${encodeURIComponent(url)}`;
        }

        text = product.text; // ui.__((product.textId + ".short") as IDS);
        name = {
            __html: product.offer ?
                (title || product.offer.marketingName || product.offer.productName) :
                ("DEBUG: " + product.channelProduct)
        };
    } else if (props.item?.type === "PLUGIN") {
        const plugin = props.item as IStorePlugin;
        url = replaceAdditionalParams(plugin.url, { productCode: props.item.productCode });
        text = plugin.text;
        name = {
            __html: plugin.name
        };
    }

    return (
        <a
            href={props.isLoading ? undefined : url}
            target="_blank"
            style={{ textDecoration: "none" }}
            onClick={props.onClick}
            role="button"
        >
            <div
                className="theme-paper-color"
                style={{
                    borderRadius: STORE_BORDER_RADIUS,
                    width: width,
                    height: 116,
                    paddingLeft: PADDING,
                    paddingRight: PADDING,
                    boxShadow: "0px 0px 10px rgba(0,0,0,0.10)",
                    overflow: "hidden",
                    cursor: "pointer",
                    display: "flex",
                    marginRight: props.marginRight,
                    marginBottom: props.marginBottom,
                    alignItems: "center"
                }}
                aria-label={`${name?.__html}. ${text}.`}
            >
                <george.StoreLoadingIndicator isLoading={props.isLoading} width="100%" height="100%" />
                {!props.isLoading && props.item &&
                    <>
                        <img
                            src={image}
                            width={80}
                            height={80}
                            style={{ marginRight: 16, borderRadius: 8, objectFit: "cover", flexShrink: 0 }}
                            alt=""
                        />
                        <div style={{ flexGrow: 1, width: width - 96 }}>
                            <pr.P_SEMI_16
                                className="theme-title-color"
                                style={{ hyphens: "auto", marginBottom: 4 }}
                                dangerouslySetInnerHTML={name}
                            />
                            <div
                                className="theme-paragraph-color"
                                style={{
                                    fontWeight: "normal",
                                    padding: 0,
                                    margin: 0,
                                    fontSize: "14px",
                                    whiteSpace: "pre-wrap"
                                }}
                            >
                                <LinesEllipsis
                                    text={text}
                                    maxLine={3}
                                    trimRight
                                    basedOn="words"
                                />
                            </div>
                        </div>
                    </>
                }
            </div>
        </a>
    );
};



// WEBPACK FOOTER //
// ./src/components/store/ProductThumbnailSmall.tsx